<template>
  <div
    ref="tableWrapper"
    class="bg-white mt-5 rounded-lg flex flex-col relative"
    :class="tableHeight"
    :style="tableWrapperStyle"
  >
    <div
      :id="id"
      ref="tableContainer"
      class="rounded-lg border border-primary-gray-200 flex-grow overflow-auto"
      @scroll.passive="onScroll"
    >
      <table class="w-full table-auto divide-y divide-primary-gray-200 whitespace-nowrap">
        <slot />
      </table>
    </div>
    <div
      v-if="rightBlurArea"
      class="w-5 bg-primary-purple-25 absolute top-px -right-0.25 opacity-80 blur-right-side rounded-tr-lg"
    ></div>
    <div
      v-if="leftBlurArea"
      class="w-5 bg-primary-purple-25 absolute top-px -left-0.25 opacity-80 blur-left-side rounded-tl-lg"
    ></div>

    <div
      v-if="leftBlurArea && swipeLeft"
      class="absolute left-0 top-0 z-[2] w-10 h-10 shadow-swipe bg-primary-purple-25 p-2 rounded-lg"
    >
      <icon icon="swipe" />
    </div>
    <div
      v-if="rightBlurArea && swipeRight"
      class="absolute right-0 top-0 w-10 h-10 shadow-swipe bg-primary-purple-25 p-2 rounded-lg z-[2]"
    >
      <icon icon="swipe" />
    </div>
  </div>
</template>

<script>
import generalMixin from '@src/mixins/general-mixins.js'
import scrollMixin from '@src/mixins/scroll-mixin'
import fileMixins from '@/src/mixins/file-mixins'
import icon from '@components/icons/icon.vue'
import { mapActions, mapState } from 'vuex'
const PAGINATION_HEIGHT_WITH_MARGIN = 110
const EXTRA_MARGIN = 60
export default {
  components: {
    icon,
  },
  mixins: [scrollMixin, fileMixins, generalMixin],
  props: {
    id: {
      type: String,
      default: 'table-container',
    },
    tableHeight: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isScrolled: false,
      viewportHeight: typeof window !== 'undefined' ? window.innerHeight : 0,
    }
  },
  computed: {
    ...mapState({
      isTabView: (state) => state.layout.isTabView,
      titleWrapperHeight: (state) => state.layout.titleWrapperHeight,
      headerOffSetHeight: (state) => state.layout.headerOffSetHeight,
      isPaginationVisiblity: (state) => state.layout.isPaginationVisiblity,
    }),
    tableWrapperStyle() {
      if (this.tableHeight) return {}
      const paginationHeight = this.isPaginationVisiblity
        ? PAGINATION_HEIGHT_WITH_MARGIN
        : EXTRA_MARGIN

      const height = this.viewportHeight
      const maxHeight = `${
        height - (this.titleWrapperHeight + this.headerOffSetHeight + paginationHeight)
      }px`

      return { maxHeight }
    },
  },
  created() {
    this.tableId = this.id
  },
  mounted() {
    this.initializeViewportObserver()
  },
  beforeUnmount() {
    this.cleanupViewportObserver()
  },
  methods: {
    initializeViewportObserver() {
      try {
        this._resizeObserver = new ResizeObserver(() => {
          this.viewportHeight = typeof window !== 'undefined' ? window.innerHeight : 0
        })
        this._resizeObserver.observe(document.body)
      } catch (e) {
        if (typeof window !== 'undefined') {
          this._onWindowResize = () => {
            this.viewportHeight = window.innerHeight
          }
          window.addEventListener('resize', this._onWindowResize)
        }
      }
    },
    cleanupViewportObserver() {
      if (this._resizeObserver) {
        this._resizeObserver.disconnect()
        this._resizeObserver = null
      }
      if (this._onWindowResize && typeof window !== 'undefined') {
        window.removeEventListener('resize', this._onWindowResize)
        this._onWindowResize = null
      }
    },
  },
}
</script>
